module.exports = __webpack_public_path__ + "img/user-ico.d41d8cd9.svg";